<template lang="html">
  <div></div>
</template>

<script type="text/javascript">
import { mapState, mapMutations } from 'vuex';
import Header from '@/components/header/Header.vue';

export default {
  name: 'CommonComponent',
  components: {
    Header,
  },
  data() {
    return ({
    });
  },

  computed: {
    ...mapState(['showMenu', 'showBackground', 'course', 'user']),
  },

  methods: {
    ...mapMutations(['setShowMenu', 'setShowBackground']),
  },

  beforeMount() {
  },

  beforeUpdate() {
  },

};
</script>